<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    attr.role="dialog"
    mode="over"
    >
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
      @for (link of masterService.links; track link; let last = $last) {
        <ui-master-item
          [link]="link"
          (handleLinkClick)="handleClick($event)"
        ></ui-master-item>
        @if (!last) {
          <mat-divider></mat-divider>
        }
      }
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary" id="nav-bar">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        >
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      @if (masterService.iconeDespachante) {
        <span>
          <img src="{{'data:image/jpg;base64,' + masterService.iconeDespachante}}" class="ico-despachante" />
        </span>
      }

      <span>
        <button [routerLink]="masterService.rota" class="button-title" mat-button>
          {{masterService.titulo}}
          @if (masterService.imgURL) {
            <img class="ico-title" src="{{masterService.imgURL}}"
              alt="Blue Route Logo"/>
          }
        </button>
      </span>
      <span class="spacer"></span>
      @if (masterService.ambiente) {
        <span>{{masterService.ambiente}}</span>
      }
      <span class="spacer"></span>
      @if (masterService.notificacao) {
        <ui-notificacao></ui-notificacao>
      }
      @if (masterService.multiConta) {
        <ui-nav-dropdown
          [itens]="masterService.itens"
          [selecionada]="masterService.itemSelecionado"
                             [selecao]="masterService.selecao"
        ></ui-nav-dropdown>
      }
      <ui-usuario-logado
        [links]="masterService.usuarioLinks"
        class="d-flex align-content-center my-auto p-2">
      </ui-usuario-logado>
    </mat-toolbar>
    <div class="container-fluid mb-4">
      <ui-loader></ui-loader>
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
